import React from 'react';
import { Icon } from '@material-ui/core';
import funnelIcon from './funnel.svg';

const FunnelIcon = () => {
    return <Icon>
        <img src={funnelIcon} height={20} width={20} style={{color: 'gray'}} />
    </Icon>
}

export default FunnelIcon
